import { MoldOrderFirstLevelType } from '../../types/mold';
import { useAppState } from '../../context/AppStateContext';
import { getDynamicIcon } from '../../utils/icon';

const MoldOrderIcon = ({ moldOrderMainType, className }: { moldOrderMainType: MoldOrderFirstLevelType | null; className?: string }) => {
  const { getHeaderStyleConfig } = useAppState();
  
  if (!moldOrderMainType) {
    return (
      <svg
        className={className || "w-8 h-8 mr-2 text-blue-600"}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
    );
  }
  
  const config = getHeaderStyleConfig(moldOrderMainType);
  const IconComponent = config.uiConfig?.icon 
    ? getDynamicIcon(config.uiConfig.icon) as React.ComponentType<{ className?: string }>
    : null;
  
  if (!IconComponent) {
    return (
      <svg
        className={className || "w-8 h-8 mr-2 text-blue-600"}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
    );
  }
  
  return <IconComponent className={className || 'w-6 h-6'} />;
}

export default MoldOrderIcon;